const config = {
    baseURL: `wss://ws.bloodgodz.com/?token=${localStorage.getItem("token")}`
}

const websocket = new WebSocket(config.baseURL);

export default websocket;